// AUTH
export const LOADING = "loading"
export const LOADING_CLEAR = "loading_clear"

export const AUTH_USER = "auth_user"
export const UNAUTH_USER = "unauth_user"
export const AUTH_ERROR = "auth_error"
